module.exports = __webpack_public_path__ + "media/images/icon-map-active-86c649fe844d93c1c61bf76381a018db.svg";